
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { union_type, class_type, record_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { AccountSettings_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";

export class State extends Record {
    constructor(Storages, AccountSettings) {
        super();
        this.Storages = Storages;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("Storage.Overview.Types.State", [], State, () => [["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AccountSettingsFetched", "StoragesFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Storage.Overview.Types.Msg", [], Msg, () => [[["Item", AccountSettings_$reflection()]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

